export default "__VITE_ASSET__c7f957be__"